import React from "react";

import AsyncSelectInput from "../../../../../components/Inputs/AsyncSelectInput";
import { Result } from "../../../../../components/Inputs/SelectInput";

import useQueryBuilderStore from "../store";

interface BaseProps {
	onChange: (value: any) => void;
	value: unknown;
}

const PersonPicker = (props: BaseProps) => {
	const valueLabelPeopleMaps = useQueryBuilderStore.getState().valueLabelMaps.people;
	const { onChange, value } = props;
	let displayValue;

	const [fetchEmployees] = useQueryBuilderStore((state) => [state.fetchEmployees]);

	// This is used since value is only the objectId, but we need a result object with the label
	// or a currently loaded employee (which may not occur due to the employee limit in this call)
	// therefore, we leverage the store's cacheing of employees to get the label.
	// The store should cache any searched employee, or any that currently exists in the filter builder.
	if (Object.keys(valueLabelPeopleMaps).filter((key) => key === value).length > 0) {
		displayValue = { value, label: valueLabelPeopleMaps[value as string] } as Result;
	}

	return <AsyncSelectInput fetchOptions={fetchEmployees} onChange={onChange} value={displayValue} />;
};

export default PersonPicker;
